import {
    AccountInfo,
    InteractionRequiredAuthError,
    IPublicClientApplication,
    RedirectRequest,
    SilentRequest,
} from "@azure/msal-browser";
import { AzureTokenInformation } from "utilities/services/auth/azure-strategies/azure-token-information";

export async function getAzureAccessToken(
    instance: IPublicClientApplication,
    accounts: AccountInfo[],
    clientId: string,
    propertyPath: string = "ACCESSTOKEN",
    showSSODebugLogs: boolean = false
): Promise<AzureTokenInformation> {
    const request = {
        account: accounts[0],
        scopes: [clientId],
    };

    try {
        return await getTokenSilent(
            instance,
            request,
            propertyPath,
            showSSODebugLogs
        );
    } catch (error) {
        if (showSSODebugLogs) {
            console.log("***Error acquiring token silently***", error);
        }
        if (error instanceof InteractionRequiredAuthError) {
            return await attemptWithRedirect(
                instance,
                request,
                showSSODebugLogs
            );
        } else {
            throw error;
        }
    }
}

async function getTokenSilent(
    instance: IPublicClientApplication,
    request: SilentRequest,
    propertyPath: string = "ACCESSTOKEN",
    showSSODebugLogs: boolean = false
): Promise<AzureTokenInformation> {
    const result = await instance.acquireTokenSilent(request);

    if (showSSODebugLogs) {
        console.log("***[getTokenSilent] Acquired token silently", result);
    }

    return {
        accessToken:
            propertyPath === "ACCESSTOKEN"
                ? result.accessToken
                : result.idToken,
        expiresOn: result.expiresOn ?? undefined,
    };
}

async function attemptWithRedirect(
    instance: IPublicClientApplication,
    request: RedirectRequest,
    showSSODebugLogs: boolean = false
): Promise<AzureTokenInformation> {
    if (showSSODebugLogs) {
        console.log("***[attemptWithRedirect] Acquiring token with redirect");
    }

    request.redirectStartPage = window.location.href;

    await instance.acquireTokenRedirect(request);

    return new Promise<AzureTokenInformation>(() => {}); // Return a pending promise to avoid further execution
}
